module.exports = __webpack_public_path__ + "static/sff_logo-022d94f1ca7b0a5434434a9ea03f6917.svg";